import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransparencyService {
  private isTransparent = new BehaviorSubject<boolean>(false);
  public readonly isTransparent$ = this.isTransparent.asObservable();

  setTransparency(value: boolean) {
    this.isTransparent.next(value);
  }
}
